import React from 'react';
import { Row, Col, Placeholder } from '@thd-olt-component-react/core-ui';

export const ChoicePlaceholders = () => {
  return (
    <Row>
      <Col fallback="3">
        <Placeholder type="rect" height="294px" width="auto" />
      </Col>
      <Col fallback="3">
        <Placeholder type="rect" height="294px" width="auto" />
      </Col>
      <Col fallback="3">
        <Placeholder type="rect" height="294px" width="auto" />
      </Col>
      <Col fallback="3">
        <Placeholder type="rect" height="294px" width="auto" />
      </Col>
    </Row>
  );
};

export const MobileChoicePlaceholders = () => {
  return (
    <Row>
      <Col fallback="4">
        <Placeholder type="rect" height="220px" width="auto" />
      </Col>
      <Col fallback="4">
        <Placeholder type="rect" height="220px" width="auto" />
      </Col>
      <Col fallback="4">
        <Placeholder type="rect" height="220px" width="auto" />
      </Col>
    </Row>
  );
};
